import styled from 'styled-components';
import { Layout } from 'antd';

export const FlexGrowDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ColorLayoutContent = styled(Layout.Content)`
  background-color: ${props => props.theme.color.pageBackground};
`;
